<template>
  <div>
    <BaseTitle :title="$t('content.class_view')" />

    <!-- Class Information -->
    <v-card class="pa-8 mb-6">
      <h3 class="app-section-title">{{ $t('content.class_name') }}</h3>
      <v-row>
        <v-col cols="12" md="3" class="py-0">
          <form-group :name="$t('form.schoolyear')">
            <template slot-scope="{ attrs }">
              <v-text-field disabled v-model="form.yearPeriode" v-bind="attrs" :label="$t('form.schoolyear')" />
            </template>
          </form-group>
        </v-col>

        <v-col cols="12" md="3" class="py-0">
          <form-group :name="$t('content.class_level')">
            <template slot-scope="{ attrs }">
              <v-select
                v-model="form.gradeId"
                v-bind="attrs"
                disabled
                item-value="gradeId"
                item-text="name"
                :items="class_level"
                :label="$t('content.class_level')"
              />
            </template>
          </form-group>
        </v-col>

        <v-col cols="12" md="3" class="py-0">
          <form-group :name="$t('content.class_sort')">
            <template slot-scope="{ attrs }">
              <v-text-field v-model="form.name" disabled v-bind="attrs" :label="$t('content.class_sort')" />
            </template>
          </form-group>
        </v-col>
        <v-col cols="12" md="3" class="py-0">
          <form-group :name="$t('form.status')">
            <template slot-scope="{ attrs }">
              <v-select :items="status" :label="$t('form.status')" v-bind="attrs" disabled v-model="form.status" width="100">
                <template #item="{item}">
                  {{ $t(item.text) }}
                </template>
                <template #selection="{item}">
                  {{ $t(item.text) }}
                </template>
              </v-select>
            </template>
          </form-group>
        </v-col>
      </v-row>
    </v-card>

    <!-- Course List -->
    <v-card class="pa-8 mb-6">
      <div class="d-flex align-items-center justify-space-between">
        <h3 class="app-section-title mb-6">{{ $t('content.course_list') }}</h3>
        <div>
          <v-btn @click="openPopNextClass" :disabled="!form.status" v-if="user.roleId === 2" color="primary" class="btn-primary-custom">
            {{ $t('content.next_class') }}
          </v-btn>

          <v-btn
            @click="goToErapor"
            v-if="user.roleId === 2 && permissionButton('ROLE_ERAPOR_VIEW')"
            color="secondary"
            class="btn-primary-custom ml-2"
          >
            {{ $t('content.erapor_template') }}
          </v-btn>
          <v-btn
            @click="goToEraporList"
            v-if="user.roleId === 2 && permissionButton('ROLE_ERAPOR_VIEW')"
            color="accent"
            class="btn-primary-custom ml-2"
          >
            {{ $t('content.erapor_list') }}
          </v-btn>
        </div>
      </div>
      <v-data-table :headers="tableHeader" :loading="table.loading" :items="form.courses" hide-default-footer class="table-custom">
        <!-- eslint-disable-next-line no-unused-vars -->
        <template #item.teachers="{ item }">
          <ul>
            <li v-for="items in item.teachers.filter(data => data.status == true)" v-bind:key="items.classroomId">{{ items.fullName }}</li>
          </ul>
        </template>
        <template #item.actions="{ item }">
          <v-btn
            color="primary"
            class="btn-primary-custom"
            :disabled="!item.classSection && !permissionButton('ROLE_CLASS_SECTION_VIEW')"
            @click="viewClassSection(item)"
          >
            {{ $t('content.view_class_section') }}
          </v-btn>
        </template>
        <template #item.students="{ item }">
          <span class="primary--text" @click="onShowItem(item.students)" style="cursor: pointer"
            >{{ item.students.filter(items => items.studentStatus == true).length }} {{ $t('content.students') }}</span
          >
        </template>
        <template #no-data>{{ $t('data_not_available') }}</template>
      </v-data-table>
    </v-card>
    <!-- Dialog Student -->
    <v-dialog v-model="dialogStudent" persistent max-width="1000">
      <v-card class="pa-6">
        <div class="d-flex align-center justify-space-between">
          <h3 class="app-section-title mb-6">{{ $t('content.student_list') }}</h3>
          <div>
            <v-text-field v-model="search" :label="$t('search')">
              <template #prepend-inner>
                <svg-icon icon="ic-search" class="primary--text mr-3" />
              </template>
            </v-text-field>
          </div>
        </div>
        <v-data-table
          :headers="tableHeader1"
          :loading="table.loading"
          :items="listStudent"
          hide-default-footer
          class="table-custom scroll"
          :search="search"
          disable-pagination
        >
          <template #no-data><NoData /></template>
        </v-data-table>
        <div class="d-flex justify-end align-center mt-4">
          <v-btn color="primary" class="btn-primary-custom" outlined @click="dialogStudent = false">{{ $t('close') }}</v-btn>
        </div>
      </v-card>
    </v-dialog>
    <!-- dialog next class -->
    <v-dialog v-model="dialogNextClass" persistent width="900">
      <v-card>
        <v-card-title class="headline secondary white--text">
          {{ $t('content.next_class') }}
        </v-card-title>
        <div class="pa-8">
          <h3 class="app-section-title">{{ $t('content.next_class_subtitle') }}</h3>
          <v-row>
            <!-- student list -->
            <v-col md="6">
              <div class="move-list">
                <div class="move-list-title">
                  <v-text-field dense filled dark rounded hide-details :label="$t('content.list_student')" single-line v-model="searchStudentNext">
                    <template #append>
                      <v-icon color="white">mdi-magnify</v-icon>
                    </template>
                  </v-text-field>
                </div>
                <div class="move-list-content">
                  <ul v-if="filterNextStudent">
                    <li v-for="item in filterNextStudent" :key="item.studentId">
                      <form-group :name="$t('content.list_student')" :validator="$v.formNext.students" :noGutter="true">
                        <template slot-scope="{ attrs }">
                          <v-checkbox
                            v-bind="attrs"
                            color="secondary"
                            v-model="formNext.students"
                            :value="item.studentId"
                            :label="`${item.fullName}`"
                          />
                        </template>
                      </form-group>
                    </li>
                  </ul>
                  <NoData v-if="filterNextStudent.length === 0" />
                </div>
              </div>
            </v-col>
            <!-- teacher list -->
            <v-col md="6">
              <div class="move-list">
                <div class="move-list-title">
                  <v-text-field dense filled dark rounded hide-details :label="$t('content.list_teacher')" single-line v-model="searchTeacherNext">
                    <template #append>
                      <v-icon color="white">mdi-magnify</v-icon>
                    </template>
                  </v-text-field>
                </div>
                <div class="move-list-content">
                  <ul v-if="filterNextTeacher">
                    <li v-for="item in filterNextTeacher" :key="item.userId">
                      <form-group :name="$t('content.list_teacher')" :validator="$v.formNext.teachers" :noGutter="true">
                        <template slot-scope="{ attrs }">
                          <v-checkbox v-bind="attrs" color="secondary" v-model="formNext.teachers" :value="item.userId" :label="`${item.fullName}`" />
                        </template>
                      </form-group>
                    </li>
                  </ul>
                  <NoData v-if="filterNextTeacher.length === 0" />
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <!-- class list -->
            <v-col md="6">
              <div class="move-list">
                <div class="move-list-title">
                  <v-text-field dense filled dark rounded hide-details :label="$t('content.list_class')" single-line v-model="searchClassroomNext">
                    <template #append>
                      <v-icon color="white">mdi-magnify</v-icon>
                    </template>
                  </v-text-field>
                </div>
                <div class="move-list-content">
                  <ul v-if="filterNextClassroom">
                    <li v-for="item in filterNextClassroom" :key="item.classroomId">
                      <form-group :name="$t('content.list_class')" :validator="$v.formNext.classroomId" :noGutter="true">
                        <template slot-scope="{ attrs }">
                          <v-radio-group v-model="formNext.classroomId" @change="getCourse(formNext.classroomId)" v-bind="attrs">
                            <v-radio color="secondary" :label="`${item.name}`" :value="item.classroomId" />
                          </v-radio-group>
                        </template>
                      </form-group>
                    </li>
                  </ul>
                  <NoData v-if="filterNextClassroom.length === 0" />
                </div>
              </div>
            </v-col>
            <!-- course list -->
            <v-col md="6">
              <div class="move-listatas">
                <div class="move-listatas-title" v-if="!isCourse">
                  <v-row>
                    <v-col md="12">
                      <div class="d-flex d-inline">
                        <v-text-field
                          class="ml-2"
                          dense
                          filled
                          dark
                          rounded
                          hide-details
                          :label="$t('content.list_course')"
                          single-line
                          v-model="searchCourseNext"
                        >
                          <template #append>
                            <v-icon color="white">mdi-magnify</v-icon>
                          </template>
                        </v-text-field>
                        <v-btn
                          @click="isCourse = true"
                          :disabled="!formNext.classroomId"
                          color="primary"
                          class="btn-primary-custom mr-2 ml-2"
                          type="submit"
                        >
                          {{ $t('content.add_course') }}
                        </v-btn>
                      </div>
                    </v-col>
                    <!-- <v-col md="4">
                      <v-btn @click="isCourse = true" :disabled="!formNext.classroomId" color="primary" class="btn-primary-custom" type="submit"
                        >Add Course</v-btn
                      >
                    </v-col> -->
                  </v-row>
                </div>
                <div class="move-listatas-title" v-if="isCourse">
                  <v-text-field dense filled dark rounded hide-details disabled label="Course" single-line>
                    {{ $t('form.course') }}
                  </v-text-field>
                </div>
                <div class="move-listatas-content">
                  <template v-if="!isCourse">
                    <v-progress-circular class="text-center" v-if="loadingClass === true" indeterminate color="primary" />
                    <ul v-if="filterNextCourse && loadingClass === false">
                      <li v-for="item in filterNextCourse" :key="item.courseId">
                        <form-group name="List Course" :validator="$v.formNext.courses" :noGutter="true">
                          <template slot-scope="{ attrs }">
                            <v-checkbox v-bind="attrs" color="secondary" v-model="formNext.courses" :value="item.courseId" :label="`${item.name}`" />
                          </template>
                        </form-group>
                      </li>
                    </ul>
                    <NoData v-if="filterNextCourse.length === 0 && loadingClass === false" />
                  </template>
                  <div v-else>
                    <div style="padding : 10px 15px;">
                      <form-group :name="$t('content.course_name')" :validator="$v.formCourse.courseId">
                        <template slot-scope="{ attrs }">
                          <v-select
                            v-bind="attrs"
                            v-model="formCourse.courseId"
                            :items="courseList"
                            item-text="name"
                            item-value="courseId"
                            :label="$t('content.course_name')"
                            persistent-hint
                            single-line
                            @input="$v.formCourse.courseId.$touch()"
                            @blur="$v.formCourse.courseId.$touch()"
                          />
                        </template>
                      </form-group>
                      <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="cancelCreateCouseNext()">{{ $t('cancel') }}</v-btn>
                      <v-btn @click="createCourseNext()" color="primary" :loading="loadingCreateCourse" class="btn-primary-custom">{{
                        $t('submit')
                      }}</v-btn>
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
        <v-divider class="mb-4" />
        <v-card-actions class="pa-3 mr-6">
          <v-spacer />
          <v-btn color="primary" class="btn-primary-custom mr-3" outlined :disabled="loadingClass" @click="cancelDialogNext">{{
            $t('cancel')
          }}</v-btn>
          <v-btn @click="submitNextClass()" color="primary" :loading="loadingClass" class="btn-primary-custom" type="submit">{{
            $t('submit')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Button Controls -->
    <div class="d-flex justify-end align-center">
      <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="backToList">{{ $t('back') }}</v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import NoData from '@/components/table/NoData';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'ViewClass',
  components: {
    BaseTitle,
    NoData
  },
  computed: {
    ...mapGetters({
      items: 'SchoolClass/items',
      status: 'Reference/itemStatus',
      years: 'Reference/itemSchoolYears',
      user: 'Auth/user',
      permission: 'Auth/permission'
    }),
    filteredResources() {
      if (this.search1) {
        return this.form.students.filter(item => {
          return item.fullName.startsWith(this.search1);
        });
      } else {
        return this.form.students;
      }
    },
    filterNextClassroom() {
      if (this.searchClassroomNext) {
        return this.listClassNextClass.filter(item => {
          return item.name.startsWith(this.searchClassroomNext);
        });
      } else {
        return this.listClassNextClass;
      }
    },
    filterNextStudent() {
      if (this.searchStudentNext) {
        return this.listStudentNextClass.filter(item => {
          return item.fullName.startsWith(this.searchStudentNext);
        });
      } else {
        return this.listStudentNextClass;
      }
    },
    filterNextTeacher() {
      if (this.searchTeacherNext) {
        return this.teacherList.filter(item => {
          return item.fullName.startsWith(this.searchTeacherNext);
        });
      } else {
        return this.teacherList;
      }
    },
    filterNextCourse() {
      if (this.searchCourseNext) {
        return this.courseListAll.filter(item => {
          return item.name.startsWith(this.searchCourseNext);
        });
      } else {
        return this.courseListAll;
      }
    },
    tableHeader() {
      return [
        { text: this.$t('table.name'), value: 'name' },
        { text: this.$t('roles.teacher'), value: 'teachers', sortable: false },
        { text: this.$t('content.total_student'), value: 'students', sortable: false },
        { text: this.$t('table.action'), value: 'actions', width: 180, sortable: false }
      ];
    },
    tableHeader1() {
      return [
        { text: this.$t('table.name'), value: 'fullName' },
        { text: 'NIS', value: 'identityNumber' }
      ];
    }
  },
  validations: function() {
    return {
      formNext: {
        classroomId: { required },
        students: { required },
        courses: { required },
        teachers: { required }
      },
      formCourse: {
        courseId: { required }
      }
    };
  },
  data: () => ({
    dialogStudent: false,
    dialogNextClass: false,
    loading: false,
    loadingClass: false,
    loadingCreateCourse: false,
    isCourse: false,
    search: '',
    search1: '',
    searchStudentNext: '',
    searchTeacherNext: '',
    searchClassroomNext: '',
    searchCourseNext: '',
    listStudent: [],
    class_level: [],
    courseList: [],
    courseListAll: [],
    teacherList: [],
    form: {
      yearPeriode: '',
      gradeId: '',
      name: '',
      status: '',
      schoolId: '',
      students: [],
      courses: []
    },
    formNext: {
      classroomId: '',
      students: [],
      courses: [],
      teachers: []
    },
    formCourse: {
      courseId: ''
    },
    table: [],
    listClassNextClass: [],
    listStudentNextClass: [],
    allPositionNull: '',
    positionNullExist: ''
  }),
  methods: {
    openPopNextClass() {
      if (this.allPositionNull) {
        this.$store.dispatch('general/showErrorNotification', { message: this.$t('content.class_level_set') });
      } else {
        this.dialogNextClass = true;
        if (this.positionNullExist) {
          this.$store.dispatch('general/showErrorNotification', { message: this.$t('content.class_level_set') });
        }
      }
    },
    getValidationCheck() {
      this.$store.dispatch('ClassAccel/positionStatus').then(data => {
        this.allPositionNull = data.allPositionNull;
        this.positionNullExist = data.positionNullExist;
      });
    },
    permissionButton(push) {
      return this.permission.some(p => p === push) ?? false;
    },
    getData() {
      this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.id).then(res => {
        Object.keys(this.form).forEach(form => (this.form[form] = res[form]));
        this.hasLoad = true;
      });
    },
    getCourse(id) {
      this.getCourseAll(id);
      this.loadingClass = true;
      this.$store
        .dispatch('NextClass/getListCouseAll', id)
        .then(res => {
          this.courseList = res;
        })
        .finally(() => (this.loadingClass = false));
    },
    cancelDialogNext() {
      this.dialogNextClass = false;
      this.formNext.classroomId = '';
      this.formNext.students = [];
      this.formNext.courses = [];
      this.formNext.teachers = [];
      this.$v.formNext.$reset();
    },
    getListClassroom() {
      this.$store.dispatch('NextClass/getListClassroom', { classId: this.$route.params.id }).then(res => {
        this.listClassNextClass = res;
      });
    },
    getListStudent() {
      this.$store.dispatch('NextClass/getListStudent', { classId: this.$route.params.id }).then(res => {
        this.listStudentNextClass = res;
      });
    },
    cancelCreateCouseNext() {
      this.isCourse = false;
      this.formCourse.courseId = '';
      this.$v.formCourse.$reset();
    },
    createCourseNext() {
      this.$v.formCourse.$touch();
      if (this.$v.formCourse.$invalid) return false;
      this.loadingCreateCourse = true;
      this.$store
        .dispatch('NextClass/addCourse', { ...this.formCourse, classroomId: this.formNext.classroomId })
        .then(({ data }) => {
          this.$store.dispatch('general/showSuccessNotification', data);
          this.isCourse = false;
          this.formCourse.courseId = '';
          this.$v.formCourse.$reset();
          this.getCourse(this.formNext.classroomId);
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loadingCreateCourse = false));
    },
    submitNextClass() {
      this.$v.formNext.$touch();
      if (this.$v.formNext.$invalid) return false;
      this.loadingClass = true;
      this.$store
        .dispatch('NextClass/create', { ...this.formNext, classIdURL: this.$route.params.id })
        .then(({ data }) => {
          this.$store.dispatch('general/showSuccessNotification', data);
          this.dialogNextClass = false;
          this.formNext.classroomId = '';
          this.formNext.students = [];
          this.formNext.courses = [];
          this.formNext.teachers = [];
          this.$v.formNext.$reset();
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loadingClass = false));
    },
    getLevel() {
      this.table.loading = true;
      this.$store
        .dispatch('Reportschool/fetchClassLevel')
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .then(res => (this.class_level = res))
        .finally((this.table.loading = false));
    },
    getCourseAll(id) {
      this.table.loading = true;
      this.$store
        .dispatch(`NextClass/getListCouse`, {
          classroomId: id
        })
        .then(data => (this.courseListAll = data))
        .finally(() => (this.table.loading = false));
    },
    getTeachers() {
      this.table.loading = true;
      this.$store
        .dispatch('Teacher/fetchList', {
          search: ''
        })
        .then(data => (this.teacherList = data))
        .finally(() => (this.table.loading = false));
    },
    backToList() {
      this.$router.push({ name: 'SchoolClassIndex' });
    },
    goToErapor() {
      this.$router.push({ name: 'eRaporTemplateSchoolAdminIndex' });
    },
    goToEraporList() {
      this.$router.push({ name: 'EraporSchoolAdminView' });
    },
    onShowItem(item) {
      this.dialogStudent = true;
      var filter = item.filter(items => items.studentStatus == true);
      this.listStudent = filter;
      this.search = '';
    },
    viewClassSection(item) {
      this.$router.push({ name: 'ViewSchoolClassSection', params: { classId: item.classroomCourseId, courseId: item.courseId } });
    }
  },
  created() {
    this.getData();
    // this.getCourseAll();
    this.getTeachers();
    this.getListClassroom();
    this.getListStudent();
    this.getLevel();
    this.getValidationCheck();
  }
};
</script>

<style lang="scss" scoped>
.move-listatas {
  &-title {
    background: #00bf63;
    color: #fff;
    font-family: Montserrat;
    font-weight: 800;
    border-radius: 8px 8px 0 0;
    width: 100%;
  }

  &-content {
    border: 1px solid #d8d8d8;
    border-radius: 0 0 8px 8px;
    padding: 10px;
    overflow: scroll;
    overflow-x: hidden;
    width: 100%;
    height: 18em;
    line-height: 2em;

    ul {
      list-style: none;
      padding: 0;

      li {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #d8d8d8;
        padding: 5px 15px;
        align-items: center;

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}
.move-list {
  &-title {
    background: #00bf63;
    color: #fff;
    font-family: Montserrat;
    font-weight: 800;
    border-radius: 8px 8px 0 0;
    padding: 10px;
    width: 100%;
  }

  &-content {
    border: 1px solid #d8d8d8;
    border-radius: 0 0 8px 8px;
    padding: 10px;
    overflow: scroll;
    overflow-x: hidden;
    width: 100%;
    height: 18em;
    line-height: 2em;

    ul {
      list-style: none;
      padding: 0;

      li {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #d8d8d8;
        padding: 5px 15px;
        align-items: center;

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}
</style>
